export enum PlayerModes {
    DEFAULT = "default",
    EXTENDED = "extended",
    PLAYLIST = "playlist",
    MICRO = "micro",
    CLOSED = "closed"
}